import { Pipe, PipeTransform } from '@angular/core'
import { remap } from '@mos/shared/utils'

@Pipe({
	name: 'remap',
	pure: true,
})
export class RemapPipe implements PipeTransform {
	transform(
		value: number,
		inputLow: number,
		inputHigh: number,
		outputLow: number = 0,
		outputHigh: number = 1,
	): number {
		return remap(value, inputLow, inputHigh, outputLow, outputHigh)
	}
}
